/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Contact_AddInputs */

const en_clients_contact_add = /** @type {(inputs: Clients_Contact_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add contact`)
};

const pt_br2_clients_contact_add = /** @type {(inputs: Clients_Contact_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar contato`)
};

/**
* | output |
* | --- |
* | "Add contact" |
*
* @param {Clients_Contact_AddInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_contact_add = /** @type {((inputs?: Clients_Contact_AddInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Contact_AddInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_contact_add(inputs)
	return pt_br2_clients_contact_add(inputs)
});